import React from 'react';
import { combineMappers } from './combineMappers.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DefaultInteractionWrapper = ({ children }) => children;
const getInteractionWrapper = ({ interactions, context }) => ({ children }) => {
  const { config } = context;
  const { contentInteractionMappers = [], onPreviewExpand = () => {
  } } = config.PREVIEW || {};
  const interactionMap = combineMappers(contentInteractionMappers, onPreviewExpand);
  return interactions.reduce((child, { type, settings }) => {
    const Interaction = interactionMap[type] || DefaultInteractionWrapper;
    return /* @__PURE__ */ React.createElement(Interaction, __spreadValues(__spreadValues({}, settings), context), child);
  }, children);
};

export { DefaultInteractionWrapper, getInteractionWrapper };
//# sourceMappingURL=getInteractionWrapper.js.map
